import { ArrowDownToLine, ArrowUpFromLine } from "lucide-react";
import { cn } from "@/ui/components/primitives/utils";

interface TransactionTypeBadgeProps {
  type: "payin" | "payout";
  className?: string;
}

export function TransactionTypeBadge({ type, className }: TransactionTypeBadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center h-6 w-6 rounded-md",
        type === "payin" && "bg-success/10 text-success",
        type === "payout" && "bg-destructive/10 text-destructive",
        className
      )}
    >
      {type === "payin" ? (
        <ArrowDownToLine className="h-4 w-4" strokeWidth={1.5} />
      ) : (
        <ArrowUpFromLine className="h-4 w-4" strokeWidth={1.5} />
      )}
    </div>
  );
}
